/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_No_Plan_HeadingInputs */

const en_us2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan starts here`)
};

const pt_br2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano começa aqui`)
};

const es_419_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan empieza aquí`)
};

const pt_pt2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano começa aqui`)
};

const fr_fr2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme commence ici`)
};

const de_de2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier beginnt dein Plan`)
};

const it_it2_today_no_plan_heading = /** @type {(inputs: Today_No_Plan_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda inizia qui`)
};

/**
* | output |
* | --- |
* | "Your plan starts here" |
*
* @param {Today_No_Plan_HeadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_no_plan_heading = /** @type {((inputs?: Today_No_Plan_HeadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_No_Plan_HeadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_no_plan_heading(inputs)
	if (locale === "es-419") return es_419_today_no_plan_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_today_no_plan_heading(inputs)
	if (locale === "fr-FR") return fr_fr2_today_no_plan_heading(inputs)
	if (locale === "de-DE") return de_de2_today_no_plan_heading(inputs)
	if (locale === "it-IT") return it_it2_today_no_plan_heading(inputs)
	return en_us2_today_no_plan_heading(inputs)
});
export { today_no_plan_heading as "today.no_plan_heading" }